import { render } from "./top-arrow.vue?vue&type=template&id=01d5e350&scoped=true"
const script = {}

import "./top-arrow.vue?vue&type=style&index=0&id=01d5e350&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01d5e350"]])

export default __exports__